<template>
  <div class="row">
    <div class="col-12">
      <h2 class="titre">
        Recherche Genre de fichier
      </h2>
    </div>
  </div>
  <CriteresRechercheGenreFichier ref="criteresRechercheGenreFichier" @rechercher="rechercher" @fermer="fermer"/>
  <!--  <ResultatRechercheCategorie/>-->
</template>

<script>

import CriteresRechercheGenreFichier from "@/components/pilotage/Fichiers/CriteresRechercheGenreFichier.vue";
import {mapGetters} from "vuex";
import axios from "axios";

export default {
  name: "RechercherGenreFichier",
  components: {
    CriteresRechercheGenreFichier
    // ResultatRechercheCategorie
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  data() {
    return {
      isRechercheDataLoading: false,
      classementGenreFichier: [],
    }
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Recherche Genre de fichier");
    /*this.isRechercheDataLoading = true;
    this.$store.dispatch('pilotage/rechercherListeEntiteAction')
      .then((res) => {
          this.$refs.criteresRechercheCategorie.assignerListe(res.data.entiteDecision);
          this.isRechercheDataLoading = false;
      });*/
  },
  methods: {
    rechercher(critereRechercheGenreFichier) {
      console.log(critereRechercheGenreFichier)
      // this.isRechercheDataLoading = true;
      // this.$store.dispatch('pilotage/rechercherGenreFichier', critereRechercheGenreFichier)
      //     .then((res) => {
      //       this.classementGenreFichier = res.data.entites;
      //       this.isRechercheDataLoading = false;
      //     })
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  }
}
</script>
